import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-pink-50 via-rose-50 to-pink-50 border-t border-pink-100 relative overflow-hidden">
      {/* Subtle sparkle background */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {[...Array(5)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute"
            style={{ left: `${i * 22 + 5}%`, top: `${20 + i * 12}%` }}
            animate={{
              scale: [0, 0.8, 0],
              opacity: [0, 0.3, 0],
              rotate: [0, 180, 360],
            }}
            transition={{
              duration: 4,
              delay: i * 0.8,
              repeat: Infinity,
            }}
          >
            <Sparkles size={12} className="text-pink-300" />
          </motion.div>
        ))}
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1">
            <h3 className="text-xl font-bold bg-gradient-to-r from-pink-500 to-rose-500 bg-clip-text text-transparent mb-4 flex items-center gap-2">
              The Pink Edit
              <motion.div
                animate={{ rotate: [0, 360] }}
                transition={{ duration: 6, repeat: Infinity, ease: "linear" }}
              >
                <Sparkles size={16} className="text-pink-400" />
              </motion.div>
            </h3>
            <p className="text-gray-600 text-sm mb-4">
              Pretty things for powerful women. Curated pink essentials for every occasion.
            </p>
            <div className="flex items-center gap-2 text-gray-600 text-sm mb-4">
              <MapPin size={16} className="text-pink-500" />
              <span>Arizona, USA</span>
            </div>
          </div>

          {/* Shop */}
          <div>
            <h4 className="font-semibold text-gray-900 mb-4">Shop</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/collections/all" className="text-gray-600 hover:text-pink-600 transition-colors">All Products</Link></li>
              <li><Link to="/collections/sweaters" className="text-gray-600 hover:text-pink-600 transition-colors">Sweaters</Link></li>
              <li><Link to="/collections/dresses" className="text-gray-600 hover:text-pink-600 transition-colors">Dresses</Link></li>
              <li><Link to="/collections/tops" className="text-gray-600 hover:text-pink-600 transition-colors">Tops</Link></li>
              <li><Link to="/collections/jewelry" className="text-gray-600 hover:text-pink-600 transition-colors">Jewelry</Link></li>
              <li><Link to="/collections/accessories" className="text-gray-600 hover:text-pink-600 transition-colors">Accessories</Link></li>
            </ul>
          </div>

          {/* Help */}
          <div>
            <h4 className="font-semibold text-gray-900 mb-4">Help</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/contact" className="text-gray-600 hover:text-pink-600 transition-colors">Contact Us</Link></li>
              <li><Link to="/shipping" className="text-gray-600 hover:text-pink-600 transition-colors">Shipping Info</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold text-gray-900 mb-4">Company</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="text-gray-600 hover:text-pink-600 transition-colors">About Us</Link></li>
              <li><Link to="/privacy-policy" className="text-gray-600 hover:text-pink-600 transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service" className="text-gray-600 hover:text-pink-600 transition-colors">Terms of Service</Link></li>
              <li><Link to="/refund-policy" className="text-gray-600 hover:text-pink-600 transition-colors">Refund Policy</Link></li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-pink-200 relative z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-600">
            <p className="flex items-center gap-1">
              © 2026 The Pink Edit. All rights reserved.
              <motion.span
                animate={{ scale: [1, 1.2, 1] }}
                transition={{ duration: 2, repeat: Infinity }}
              >
                <Sparkles size={12} className="text-pink-400" />
              </motion.span>
            </p>
            <div className="flex items-center space-x-4 mt-4 md:mt-0">
              <span>We accept:</span>
              <div className="flex space-x-2">
                <div className="px-3 py-1 bg-white rounded border border-gray-200 text-xs font-medium">Visa</div>
                <div className="px-3 py-1 bg-white rounded border border-gray-200 text-xs font-medium">Mastercard</div>
                <div className="px-3 py-1 bg-white rounded border border-gray-200 text-xs font-medium">PayPal</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
